import { getAnalyticsService, AnalyticsEvent } from './index';

export interface TrackSortChangedOptions {
  sortKeys: string[];
  sortDirections: string[];
  interactionIndex: number;
  rowsVisibleCount?: number;
}

export const trackSortChanged = ({
  sortKeys,
  sortDirections,
  interactionIndex,
  rowsVisibleCount,
}: TrackSortChangedOptions): void => {
  const service = getAnalyticsService();
  service.trackEvent(AnalyticsEvent.SortChanged, {
    sort_keys: sortKeys,
    sort_directions: sortDirections,
    interaction_index: interactionIndex,
    ...(rowsVisibleCount !== undefined && { rows_visible_count: rowsVisibleCount }),
  });
};
